/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Vendor_NameInputs */

const vi_expense_vendor_name = /** @type {(inputs: Expense_Vendor_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị / Người nhận`)
};

/**

* @param {Expense_Vendor_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_vendor_name = /** @type {((inputs?: Expense_Vendor_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Vendor_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_vendor_name(inputs)
});